@if (url$ | async; as url) {
  @if (blockEmployeeSwitchDialog()) {
    <div class="avatar">
      <div>
        <img [src]="url" alt="pic" />
      </div>
    </div>
  } @else {
    <button type="button" class="avatar" (click)="onEmployeeClick(); $event.stopPropagation()">
      <div>
        <img [src]="url" alt="pic" />
      </div>
    </button>
  }
} @else {
  @if (blockEmployeeSwitchDialog()) {
    <div class="avatar avatar-placeholder">
      <div class="text-white" [style.background-color]="getBackgroundColorForIndex(colorIndex())">
        <span>{{ $initials() }}</span>
      </div>
    </div>
  } @else {
    <button type="button" class="avatar avatar-placeholder" (click)="onEmployeeClick(); $event.stopPropagation()">
      <div class="text-white" [style.background-color]="getBackgroundColorForIndex(colorIndex())">
        <span>{{ $initials() }}</span>
      </div>
    </button>
  }
}
